import React from 'react';
import FileInput from '../../components/Inputs/FileInput';
import Button from '../../components/landingPage/Button';
import useNotification from '../../store/notification/notificationContext';
import { NOTIFICATIONS } from '../../config';

function CareerForm({sendForm}) {
  const { setNotification } = useNotification();

  const [userInfo, setUserInfo] = React.useState({
    name:"",
    email:"",
    phone_nb:"",
    message:"",
    cv: null
  })

  const [formSuccess, setFormSuccess] = React.useState(undefined);
  const [formError, setFormError] = React.useState({
    field: '',
    msg:''
  })

  const handleCVUpload= (e) => {
    if (e.target.files[0].type !== 'application/pdf') return setFormError({
      field: 'cv',
      msg: "Please add your CV in a .pdf file"
    })

    if (formError?.field === 'cv') setFormError({
      field: '',
      msg: ''
    })
    setUserInfo((prevState) => ({ ...prevState, cv: e.target.files[0] }));
  }

  function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  const handleSubmit = () => {
    
    if (!userInfo.name) return setFormError({
      field: 'name',
      msg:  "Please add your name." 
    });
    if (!validateEmail(userInfo.email)) return setFormError({
      field: 'email',
      msg:  "Please add a valid email." 
    });
    if (!userInfo.phone_nb) return setFormError({
      field: 'phone_nb',
      msg:  "Please enter a valid phone number." 
    });
    if (!userInfo.cv) return setFormError({
      field: 'cv',
      msg:  "Please add your CV in a .pdf file" 
    });
    if (userInfo.cv.type !== 'application/pdf') return setFormError({
      field: 'cv',
      msg: "Please add your CV in a .pdf file"
    })
    setFormError({
      field: '',
      msg: ''
    })
    sendForm(userInfo).then(res => {
      setFormSuccess(true);
      setUserInfo({
        name:"",
        email:"",
        phone_nb:"",
        message:"",
        cv: null
      });
      setTimeout(() => {
        setFormSuccess(false);
      }, 5000);
    }).catch(err => {
      console.log('error', err.message)
      setFormSuccess(false)
      setTimeout(() => {
        setFormSuccess(undefined);
      }, 5000);
    })
  }

  return (
    <div className="flex flex-col items-center p-8 w-full max-w-3xl text-center mx-auto text-lg">
      <div className="flex flex-col w-full max-w-3xl my-4">
        <h1 className="text-2xl font-bold my-2">Join our team</h1>
        <p>It doesn’t matter where you come from, where you went to school or what industry you’re in — if you’ve done exceptional work, join us to rethink the future of dentistry and digital dental design.</p>
      </div>
      <div className="flex flex-col gap-4 pb-6 w-full max-w-6xl">
        <input type="text" label="name" placeholder="Name" className="placeholder-lpGray px-4 mt-2 h-10 bg-bgGray rounded" value={userInfo.name} onChange={(e) => {setUserInfo((prevState)=> ({...prevState, name:e.target.value}))}}></input>
        {formError.field === 'name' && 
        <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
        }
        <input type="email" label="email" placeholder="Email" className="placeholder-lpGray px-4 mt-2 h-10 bg-bgGray rounded" value={userInfo.email} onChange={(e) => {setUserInfo((prevState)=> ({...prevState, email:e.target.value}))}}></input>
        {formError.field === 'email' && 
        <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
        }
        <input type="phone_nb" label="phone_nb" placeholder="Phone number" className="placeholder-lpGray px-4 mt-2 h-10 bg-bgGray rounded" value={userInfo.phone_nb} onChange={(e) => {setUserInfo((prevState)=> ({...prevState, phone_nb:e.target.value}))}}></input>
        {formError.field === 'phone_nb' && 
        <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
        }
        <textarea label="message" placeholder="Tell us about yourself" rows="4" className="message placeholder-lpGray resize-none px-4 py-2 mt-2 bg-bgGray rounded" value={userInfo.message} onChange={(e) => {setUserInfo((prevState)=> ({...prevState, message:e.target.value}))}}></textarea>
        {formError.field === 'message' && 
        <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
        }
        <FileInput resetFiles={formSuccess} buttonText="Upload your CV" className="self-start" right handleFileUpload={handleCVUpload} accept="application/pdf"/>
        {formError.field === 'cv' && 
        <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
      }
        <Button text="Submit" className="w-full mt-2" onClick={()=>{handleSubmit()}}/>
      {formSuccess === true && 
      <span className="text-green-600 text-sm col-span-4">Message sent successfully!</span>
      }
      {formSuccess === false &&
      <span className="text-red-600 text-sm col-span-4">Error while sending message, please try again</span>}
      </div>
    </div>
  )
}


export default CareerForm;
